<script setup lang="ts">
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';

const { title = '', content } = defineProps<{ title?: string, content: string }>();
</script>

<template>
  <sl-tooltip hoist="true" distance="4">
    <div slot="content">
      <div v-if="title" class="title">{{ title }}</div>
      <div class="content" v-html="content" />
    </div>
    <slot/>
  </sl-tooltip>
</template>

<style scoped lang="postcss">
sl-tooltip {
  --sl-tooltip-arrow-size: 0;
  --max-width: 300px;

  &::part(body) {
    padding: 12px;
    background-color: var(--colors-neutral-dark_blue-60);
    border-radius: 4px;
    margin: 0 4px;
  }
}

.title {
  font-family: var(--font_family-accent);
  color: var(--color-white-100);
  font-size: var(--font_size-base-l);
  line-height: var(--line_height-l);
  margin-bottom: 8px;
}

.content {
  font-family: var(--font_family-main);
  color: var(--color-neutral-gray-70);
  font-size: var(--font_size-base-s);
  line-height: var(--line_height-m);
}
</style>
